import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Stylist } from '../../../models/stylist/stylist.model';
import { Discount } from '../../../models/discount/discount.model';
import { Lineitem } from '../../../models/line-item/line-item.model';
import { UserService } from '../../../services/user.service';
import { SalonService } from '../../../services/salon.service';
import { StylistService } from '../../../services/stylist.service';
import { Utilities } from '../../../utilities/utilities';
import { List } from 'immutable';
//import { StylistDiscountFormCallBackData } from '../../settings/pos-settings/stylist-discount-form.page';
//import { SalonDiscountFormCallBackData } from '../../settings/pos-settings/salon-discount-form.page';

// import 'rxjs/add/operator/switchMap';

import { SalonDiscountFormComponent } from '../../../settings/pos-settings/discounts/salon-discounts/salon-discount-form/salon-discount-form.component'
import { StylistDiscountFormComponent } from '../../../settings/pos-settings/discounts/stylist-discounts/stylist-discount-form/stylist-discount-form.component'
import { switchMap } from 'rxjs/operators';
declare var posthog: any;
export interface SaleDiscountListModalCallBackData {
  discount: Discount
}

@Component({
  selector: 'app-sale-discount-list',
  templateUrl: './sale-discount-list.page.html',
  styleUrls: ['./sale-discount-list.page.scss'],
})
export class SaleDiscountListPage implements OnInit {

  @Input() lineitem: Lineitem;

  public myDiscounts: List<Discount>;

  public salonDiscounts: List<Discount>;

  public isDiscountListLoading: boolean;

  public errorOccurredWhileLoadingDiscounts: boolean;

  public user: Stylist;

  public selectedDiscountID: number;

  constructor (
              //private navParams: NavParams,
              //private viewCtrl: ViewController,
              private SalonService: SalonService,
              private stylistService: StylistService,
              private modalController: ModalController,
              private userService: UserService) {
    //this.lineitem = this.navParams.get('lineitem');
    this.errorOccurredWhileLoadingDiscounts = false;
    this.user = this.userService.getUser();
    this.myDiscounts = List([]);
    this.salonDiscounts = List([]);
    this.selectedDiscountID = -1;
  }

  public ngOnInit () {
    this.loadDiscounts();
  }

  public onDismiss () {
    //this.viewCtrl.dismiss();
    this.modalController.dismiss();
  }

  public tapToRetry() {
    this.loadDiscounts();
  }

  public loadDiscounts () {
    this.isDiscountListLoading = true;
    this.errorOccurredWhileLoadingDiscounts = false;
    this.myDiscounts = List([]);
    this.salonDiscounts = List([]);
    this.stylistService.getDiscounts(this.user)
      .pipe(
         switchMap((myDiscounts: List<Discount>) => {
          this.myDiscounts = myDiscounts;
          return this.SalonService.getSalonDiscounts();
        })
      )
      .subscribe({
        next:(salonDiscounts: List<Discount>) => {
        this.isDiscountListLoading = false;
        this.salonDiscounts = salonDiscounts;

        // find selected index of the discount
        const lineitemDiscount: Discount = this.lineitem.discount;
        let counter: number = 0;
        if (lineitemDiscount) {
          const combinedDiscounts: List<Discount> = this.myDiscounts.push(... this.salonDiscounts.toJSON());

          combinedDiscounts.some((discount: Discount) => {

            if (
              lineitemDiscount.name === discount.name &&
              lineitemDiscount.type === discount.type &&
              lineitemDiscount.amount === discount.amount) {
              this.selectedDiscountID = lineitemDiscount.id;
              return true;              
            }

            counter++;
          });
        }

      },
      error: (e) => {
        this.isDiscountListLoading = false;
        this.errorOccurredWhileLoadingDiscounts = true;

      }
    });
  }

  public onDiscountTap (discount: Discount) {
    const data: SaleDiscountListModalCallBackData = {
      discount: discount
    };

    this.modalController.dismiss(data);
    
  }

  public async onAddMyDiscount () {
    const discount: Discount = new Discount({
      id: undefined,
      name: '',
      type: 0,
      amount: 0,
      discountCommission: 0,
      stylistID: this.user.id
    });

    const modal = await this.modalController.create({
      component: StylistDiscountFormComponent, 
      componentProps:{ discount: discount}
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.myDiscounts = this.myDiscounts.push(data.data.discount); 
        }
      }
    });
    await modal.present();
  }

  public async onAddSalonDiscount () {
    const discount: Discount = new Discount({
      id: undefined,
      name: '',
      type: 0,
      amount: 0,
      discountCommission: 0,
      stylistID: undefined
    });
    const modal = await this.modalController.create({
      component: SalonDiscountFormComponent, 
      componentProps: {discount: discount}
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        if (data.data.action === 'save') {
          this.salonDiscounts = this.salonDiscounts.push(data.data.discount); 
        }
      }
    });
    await modal.present();
  }

}
